import nodeClient from "configurations/nodeClient";

export const getFirebaseToken = (username, password) => {
  return nodeClient.post(`/v1/auth/login`, { username, password });
};
